function styleFormEmbed () {
  const host = document.querySelector("shopify-forms-embed");
  if (!host || !host.shadowRoot) return false;

  const container = host.shadowRoot.querySelector(
    'button[type="submit"]'
  );

  if (!container) return false;

  if (host.shadowRoot.querySelector("style[data-custom-style]")) return true;

  const svgNS = "http://www.w3.org/2000/svg";
  const svg = document.createElementNS(svgNS, "svg");
  svg.setAttribute("width", "21");
  svg.setAttribute("height", "20");
  svg.setAttribute("viewBox", "0 0 21 20");
  svg.setAttribute("fill", "none");

  const path1 = document.createElementNS(svgNS, "path");
  path1.setAttribute("d", "M15.5 10.0039H5.5");
  path1.setAttribute("stroke", "#1F1F1F");
  path1.setAttribute("stroke-width", "1.5625");
  path1.setAttribute("stroke-linejoin", "round");

  const path2 = document.createElementNS(svgNS, "path");
  path2.setAttribute("d", "M10.5 5L15.5 10L10.5 15");
  path2.setAttribute("stroke", "#1F1F1F");
  path2.setAttribute("stroke-width", "1.5625");
  path2.setAttribute("stroke-linejoin", "round");

  svg.appendChild(path1);
  svg.appendChild(path2);

  const textNode = document.createTextNode("CONFIRM ");
  const containerSpan = document.createElement("span");
  containerSpan.appendChild(textNode);
  containerSpan.appendChild(svg);

  container.innerHTML = "";
  container.appendChild(containerSpan);

  const style = document.createElement("style");
  style.setAttribute("data-custom-style", "true");
  style.textContent = `
    form._formFieldset_cit2d_82 {
      flex-flow: wrap !important;
      gap: 16px 24px !important;
    }

    @media screen and (max-width: 960px) {
      form._formFieldset_cit2d_82 {
        gap: 16px !important;
      }
    }

    ._formFieldset_cit2d_82 > div:not(._formFieldContainer_1mxsl_5) {
      display: none;
    }

    ._noImage_1q1d2_161 {
      max-width: 680.38px !important;
      margin: 0 !important;
      gap: 16px;
    }

    h2._textHeading_2aowh_35 {
      width: fit-content;
      color: #1F1F1F !important;
      font-family: "Albert Sans" !important;
      font-size: 40px !important;
      font-style: normal !important;
      font-weight: 400 !important;
      line-height: 113% !important;
      letter-spacing: 0.4px !important;
    }
    ._formHeader_cit2d_24,
    h2._textHeading_2aowh_35 {
      margin: 0 !important;
      margin-bottom: 16px !important;
    }

    ._formFieldContainer_ck6wz_5 {
      max-width: calc(100% - 127.05px - 16px);
      order: 1;
      flex: 1;
    }

    ._formError_ck6wz_21 {
      order: 3;
      width: 100%;
    }

    ._formFieldContainer_1mxsl_5 {
      max-width: calc(100% - 12.705rem - 2.4rem);
      flex: 1;
    }

    input[type="text"], input[type="email"] {
      height: 60px !important;
      box-sizing: border-box !important;
      border-radius: 4px !important;
      border: 1px solid rgba(31, 31, 31, 0.16) !important;
      background: transparent !important;

      color: rgba(55, 55, 55, 0.60) !important;
      font-family: "Albert Sans" !important;
      font-size: 16px !important;
      font-style: normal !important;
      font-weight: 400 !important;
      line-height: normal !important;
      letter-spacing: 0.64px !important;
    }

    label._formInputFieldLabel_1mxsl_38 {
      top: 23px !important;
    }

    ._consentCheckboxContainer_cit2d_49 {
      order: 4;
      width: 100%;
    }

    ._checkboxField_1hja3_3 {
      grid-template-columns: auto minmax(0, 1fr) !important;
    }

    #emailConsent-true {
      margin: 0;
      width: 16px;
      height: 16px;
      appearance: none;
      border-radius: 4px;
      border: 1px solid rgba(31, 31, 31, 0.08);
      background: rgba(31, 31, 31, 0.1);
      color: #1f1f1f;
      cursor: pointer;
    }

    #emailConsent-true:checked {
      background: linear-gradient(currentColor) center no-repeat;
      background-size: 1.2rem 1.2rem;
    }

    ._textBody_2aowh_10 {
      color: #1F1F1F !important;
      font-family: "Albert Sans" !important;
      font-size: 14px !important;
      font-style: normal !important;
      font-weight: 400 !important;
      line-height: normal !important;
      letter-spacing: -0.28px !important;
      text-transform: uppercase !important;
      cursor: pointer;
    }

    button[type="submit"] {
      height: 60px !important;
      box-sizing: border-box !important;
      color: #1F1F1F !important;
      text-align: center !important;
      font-family: "Albert Sans" !important;
      font-size: 16px !important;
      font-style: normal !important;
      font-weight: 600 !important;
      line-height: normal !important;
      letter-spacing: -0.32px !important;
      text-transform: uppercase !important;
      order: 2 !important;
      padding: 20px 24px !important;
      border-radius: 12px !important;
    }

    button[type="submit"] span {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 2px;
    }

    @media screen and (max-width: 960px) {
      h2._textHeading_2aowh_35 {
        font-size: 36px !important;
      }
      button[type="submit"] {
        padding: 16px !important;
      }
    }
  `;
  host.shadowRoot.appendChild(style);

  return true;
}

// Shopify Forms 是外部 app 注入的，可能因为 app 停用 / 被拦截而永远不出现。
// 原来这个轮询只在成功时 clearInterval，失败就每 500ms 查一次 shadowRoot 查到关页面。
// 给它一个上限：60 次 = 30 秒，够 app 脚本 defer 加载完还有富余。
const FORM_EMBED_MAX_TRIES = 60;
let formEmbedTries = 0;
const interval = setInterval(() => {
  formEmbedTries += 1;
  if (styleFormEmbed() || formEmbedTries >= FORM_EMBED_MAX_TRIES) {
    clearInterval(interval);
  }
}, 500);
